import { FC } from "react";
import { Tooltip } from "@infobis/ui-styles-utils";
import {TooltipProps} from "@infobis/ui-styles-utils/components/Tooltip/Tooltip";

interface InlineTooltipProps {
    value: string | number
    trigger?: TooltipProps['trigger']
}

const InlineTooltip: FC<InlineTooltipProps> = (props) => {
    const {
        value,
        trigger = 'static'
    } = props;
    return (
        <Tooltip text={value} hideOnAnywhereClick={false} trigger={trigger} />
    )
}

export default InlineTooltip;